import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';

const CreateRool = ({ onClose, roolId }) => {

  const { handleSubmit } = useForm();
  const [roolName, setRoolName] = useState(roolId?.roolname || '');

  const data = [
    { customId: '1', name: 'package' },
    { customId: '2', name: 'event' },
    { customId: '3', name: 'rool' },
    { customId: '4', name: 'user' },
  ];

  const initializePermissions = () => {
    return data.reduce((acc, item) => {
      const existingPermission = roolId?.name?.find((perm) => perm.customId === item.customId);
      acc[item.name] = {
        id: item.customId,
        fullAccess: existingPermission
          ? existingPermission.view === 'true' &&
            existingPermission.create === 'true' &&
            existingPermission.edit === 'true' &&
            existingPermission.delete === 'true' &&
            existingPermission.export === 'true'
          : false,
        view: existingPermission ? existingPermission.view === 'true' : false,
        create: existingPermission ? existingPermission.create === 'true' : false,
        edit: existingPermission ? existingPermission.edit === 'true' : false,
        delete: existingPermission ? existingPermission.delete === 'true' : false,
        export: existingPermission ? existingPermission.export === 'true' : false,
      };
      return acc;
    }, {});
  };

  const [permissions, setPermissions] = useState(initializePermissions);

  useEffect(() => {
    setPermissions(initializePermissions());
  }, [roolId]);

  const handleFullAccessChange = (name) => (e) => {
    const isChecked = e.target.checked;
    setPermissions((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        fullAccess: isChecked,
        view: isChecked,
        create: isChecked,
        edit: isChecked,
        delete: isChecked,
        export: isChecked,
      },
    }));
  };

  const handleCheckboxChange = (name, field) => (e) => {
    const isChecked = e.target.checked;
    setPermissions((prev) => {
      let updated = { ...prev[name], [field]: isChecked, fullAccess: false };
      if (field === 'create' && isChecked) {
        updated.view = true;
      }
      if (field === 'edit' && isChecked) {
        updated.view = true;
        updated.create = true;
      }
      if (field === 'delete' && isChecked) {
        updated.view = true;
        updated.delete = true;
      }
      if (field === 'export' && isChecked) {
        updated.view = true;
        updated.export = true;
      }
      if (
        updated.view &&
        updated.create &&
        updated.edit &&
        updated.delete &&
        updated.export
      ) {
        updated.fullAccess = true;
      }
      return { ...prev, [name]: updated };
    });
  };

  const onSubmit = async(data) => {
    const requestData = roolId ? { id: roolId, roolName, permissions } : { roolName, permissions };

    console.log("Submitted Data:", requestData); // Debugging log

    try {
        const response = await axios.post('http://localhost:4000/roolpast', requestData);
        console.log('Response:', response.data);

        if (typeof onClose === 'function') {
            console.log("Closing section...");
            onClose();
        }
    } catch (error) {
        console.error('Error creating/updating application:', error);
        console.error("Error Response Data:", error.response?.data);
    }
};



  
  

  return (
    <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Create Role</h5>
          <button type="button" className="btn-close" onClick={onClose}></button>
        </div>
        <div className="modal-body " ></div>
      <form id="formAuthentication" className="mb-3 p-2" onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-2">
          <label htmlFor="roolName" className="form-label">
          Role Name <span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="roolName"
            value={roolName}
            onChange={(e) => setRoolName(e.target.value)}
            placeholder="Enter Rool Name"
            autoFocus
            required
          />
        </div>

      
        <div className="mb-2">
          {/* {data.map((item) => ( */}
            <div >
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Full access</th>
                    <th>View</th>
                    <th>Create</th>
                    <th>Edit</th>
                    <th>Delete</th>
                    <th>Export</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item) => (
                    <tr key={item.customId}>
                    <td><label className="list-group-item">{item.name}</label></td>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input mt-1"
                        checked={permissions[item.name].fullAccess}
                        onChange={handleFullAccessChange(item.name)}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input mt-1"
                        checked={permissions[item.name].view}
                        onChange={handleCheckboxChange(item.name, 'view')}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input mt-1"
                        checked={permissions[item.name].create}
                        onChange={handleCheckboxChange(item.name, 'create')}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input mt-1"
                        checked={permissions[item.name].edit}
                        onChange={handleCheckboxChange(item.name, 'edit')}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input mt-1"
                        checked={permissions[item.name].delete}
                        onChange={handleCheckboxChange(item.name, 'delete')}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input mt-1"
                        checked={permissions[item.name].export}
                        onChange={handleCheckboxChange(item.name, 'export')}
                      />
                    </td>
                  </tr>
                  ))}
                  
                </tbody>
              </table>
            </div>
          {/* ))} */}
        </div>

        <div className="modal-footer">
          <button type="submit" className="btn btn-primary">
            Save
          </button>
        </div>
      </form>
      </div>
      
      </div>
    </div>
  );
};

export default CreateRool;
